import genhelpmethods from '../genhelpmethods';
/**
 *
 * @param {*} component
 * @param {*} arr
 * @param {*} profileUtils
 */
let exportToCSV = (component,arr,profileUtils) => {
    let self = component;
    genhelpmethods.sortJSON(arr, 'OrderDate', '321');
    let csv = '';
    let i;
    csv += '"' +
        self.txc.order_number.replace('#','') + '","' +
        self.txc.date  + '","' +
        self.txc.total  + '","' +
        self.txc.psv  + '","' +
        self.txc.order_status + '"\n';
    for (i = 0; i < arr.length; i++) {
        csv +=
            '"' +
            arr[i].OrderNumber +
            '","' +
            component.formatDateString(arr[i].OrderDate) +
            '","' +
            arr[i].Amount +
            '","' +
            arr[i].PSV +
            '","' +
            self.statusTranslate(arr[i].Status) +
            '"\n';
    }
    let hiddenElement = document.createElement('a');
    let universalBOM = '\uFEFF';
    hiddenElement.href = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csv);
    hiddenElement.target = '_blank';
    let filename = self.txc.title + '.csv';
    filename = filename.replace(/ /g,'_');
    hiddenElement.download = filename;
    hiddenElement.click();
    profileUtils.publishAnalytics(component.$analytics.category.orders, 'history', 'csv_exported');
}
/**
 *
 * @param {*} component
 * @param {*} ProfileService
 * @param {*} months
 * @param {*} updateFilter
 */
let loadOrders =(component,ProfileService,months, updateFilter)=>{
    component.processing = true;
    let self = component;
    ProfileService.getOrderHistory(months).then(function (response) {
        let responseList = response.data.SalesOrderStatusResponse.OrderStatus;
        self.orders = responseList;
        self.orders.forEach((element, x) => {
            if (element.Tracking != null) {
                self.addTrackingInfo({id: element.OrderNumber, 'Tracking':element.Tracking});
            }
        });
        self.filteredOrders = responseList;
        genhelpmethods.sortJSON(self.filteredOrders, 'OrderDate', '321');
        self.processing = false;
        if (updateFilter) {
            self.runFilters();
        }
    });
}
/**
 *
 * @param {*} component
 */
let clearFilters = (component)=>{
    component.statusFilter = {};
    component.dateFilter = {};
    component.filteredOrders = component.orders;
}
/**
 *
 * @param {*} component
 * @param {*} selected
 * @param {*} moment
 */
let filterDate = (component,selected,moment)=>{
    let d = new Date();
    let ts = d.getTime();

    component.filteredOrders = component.orders.filter(
        order =>
            moment(order.OrderDate).format('x') >=
            moment(ts)
                .subtract(selected, 'months')
                .format('x')
    );
}
/**
 *
 * @param {*} component
 * @param {*} selected
 */
let filterStatus = (component,selected)=>{
    component.filteredOrders = component.filteredOrders.filter(
        order => order.Status === selected.value
    );
}
/**
 *
 * @param {*} component
 */
let runFilters = (component)=>{
    component.filteredOrders = component.orders;
    if (component.dateFilter.value) {
        component.filterDate(component.dateFilter.value);
    }
    if (component.statusFilter.value) {
        component.filteredOrders = component.filteredOrders.filter(
            order => order.Status === component.statusFilter.value
        );
    }
    if (component.filteredOrders.length === 0) {
        component.noOrders = true;
    } else {
        component.noOrders = false;
    }
    genhelpmethods.sortJSON(component.filteredOrders, 'OrderDate', '321');
}
/**
 *
 * @param {*} component
 */
let checkFilters = (component)=>{
    if (component.loadedAllOrders) {
        component.runFilters();
    } else {
        component.loadedAllOrders = true;
        component.loadOrders(11, true);
    }
}
/**
 *
 * @param {*} component
 * @param {*} item
 */
let removeFilter = (component,item)=>{
    if (item === 'date') {
        component.dateFilter = {};
        runFilters(component);
    }
    if (item === 'status') {
        component.statusFilter = {};
        runFilters(component);
    }
}
/**
 *
 * @param {*} component
 * @param {*} orderNumber
 * @param {*} profileUtils
 */
let showDetails = (component,orderNumber,profileUtils)=>{
    component.$router.push({
        name: 'orderDetail',
        params: {ordernumber: orderNumber}
    });
    window.scrollTo(0, 0);
    profileUtils.publishAnalytics(component.$analytics.category.orders, 'order_detail', 'view');
}
/**
 *
 * @param {*} component
 * @param {*} status
 */
let statusTranslate = (component,status)=>{
    switch (status) {
        case 'BACKORDER':
            return (component.txc.backorder);
        case 'CANCELLED':
            return (component.txc.cancelled);
        case 'COMPLETE':
            return (component.txc.complete);
        case 'DECLINED':
            return (component.txc.declined);
        case 'INCOMPLETE':
            return (component.txc.incomplete);
        case 'PARTIAL_RETURN':
            return (component.txc.partial_return)
        case 'PAYMENT_PENDING':
            return (component.txc.payment_pending);
        case 'PENDING':
            return (component.txc.pending)
        case 'PENDING_RETURN':
            return (component.txc.pending_return);
        case 'PROCESSING':
            return (component.txc.processing);
        case 'RETURNED':
            return (component.txc.returned);
    }
    return 'default';
}
/**
 *
 * @param {*} component
 */
let mounted= (component)=>{
    component.dateFilter = {text: component.txc.filterOrderDate1Month, value: '1'};
    component.statusFilter = {text: component.txc.filterOrderStatusAll, value: ''};
    component.loadOrders(1, false);
}

export default {
    loadOrders: loadOrders,
    exportToCSV:exportToCSV,
    clearFilters:clearFilters,
    filterDate:filterDate,
    filterStatus:filterStatus,
    runFilters:runFilters,
    checkFilters:checkFilters,
    removeFilter:removeFilter,
    showDetails:showDetails,
    statusTranslate:statusTranslate,
    mounted:mounted
};
